﻿import { IRccapAdditionalQuestionRequest } from './rccap-additional-question-request';

export interface IRccapRequest {
    id: number;
    currentStatus: number;
    responsibleCenterId: number;
    recipientCenterId: number;
    recipientAlias: string;
    recipientPmpc: string;
    recipientCpra: string;
    recipientAbo: string;
    recipientsDonorAbo: string;
    matchOfferDate: string;
    exmRequestDate: string;
    failDate: string;
    targetSurgeryDate: string;
    dueDate: string;
    responseDate: string;
    donorCenterId: number;
    donorAlias: string;
    rccapManagerId: number;
    rccapRequesterId: number;
    swapChainNumber: number;
    swapClusterNumber: number;
    swapPositionNumber: number;
    transplantsImpacted: number;
    whatHappened: string;
    additionalQuestions: IRccapAdditionalQuestionRequest[];
    rootCausePrimaryId: number;
    rootCauseSecondaryId: number;
    rootCauseInfo: string;
    rootCauseAdditional: string;
    avoidable: number;
    billable: number;
    phase: number;
    correctiveActionPrimary: number;
    correctiveActionSecondary: number;
    correctiveActionInfo: string;
    correctiveActionAdditional: string;
    responder: string;
    shortAdminCorrectiveAction: string;
    shortAdminRootCause: string;
    additionalComments: string;
    satisfactoryResponse: number;
    sendEmail: boolean;
}
